'use client';

import * as React from 'react';
import ChangeRolesModalContent from '@/app/dashboard/staff-settings/all-staff/components/change-roles-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function ChangeRolesModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Change Role" isOpen={modal?.open === ModalDrawer.CHANGE_ROLES}>
      <ChangeRolesModalContent />
    </ModalLayout>
  );
}
